import { render, staticRenderFns } from "./SectionPageHeading.vue?vue&type=template&id=508caaf0&scoped=true"
import script from "./SectionPageHeading.vue?vue&type=script&lang=ts"
export * from "./SectionPageHeading.vue?vue&type=script&lang=ts"
import style0 from "./SectionPageHeading.vue?vue&type=style&index=0&id=508caaf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508caaf0",
  null
  
)

export default component.exports